import React__default, { useReducer, createContext, useContext, useState, useEffect, createElement, Fragment as Fragment$1 } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { get, isEmpty, pickBy, identity, merge } from 'lodash';
import { navigate } from 'gatsby';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var Reducer = function Reducer(state, action) {
  switch (action.type) {
    case "DATA_LOADING":
      var params = {
        loading: true,
        error: false,
        success: false,
        message: ""
      };
      if (action !== null && action !== void 0 && action.payload) params = _extends({}, params, action.payload);
      return _extends({}, state, params);
    case "GET_SAVED_PROPERTIES":
      var savedItems = {};
      if (action.payload) {
        savedItems = action.payload.data;
      }
      return _extends({}, state, {
        loading: false,
        userObjects: _extends({}, state.userObjects, savedItems)
      });
    case "GET_PROPERTIES":
      return _extends({}, state, {
        properties: action.payload
      });
    case "SAVE_PROPERTY":
      return _extends({}, state, {
        userObjects: _extends({}, state.userObjects, action.payload.data)
      });
    case "UPDATE_SAVED_PROPERTY":
      return _extends({}, state, {
        userObjects: _extends({}, state.userObjects, action.payload.data)
      });
    case "DELETE_SAVED_PROPERTY":
      var userObjects = state.userObjects[action.payload.type];
      if (state.userObjects[action.payload.type] && state.userObjects[action.payload.type].length) {
        userObjects = {};
        userObjects[action.payload.type] = state.userObjects[action.payload.type].filter(function (x) {
          return x.id !== action.payload.id;
        });
      }
      return _extends({}, state, {
        userObjects: _extends({}, state.userObjects, userObjects)
      });
    case "UNSUBSCRIBE":
      return _extends({}, state, {
        loading: false,
        success: true,
        unsubscribe: action.payload
      });
    case "ERROR":
      return _extends({}, state, {
        loading: false,
        error: true,
        success: false,
        message: action.payload.data.message,
        status: action.payload.status
      });
    case "SERVICE_ERROR":
      return _extends({}, state, {
        loading: false,
        error: true,
        success: false,
        message: action.payload.message,
        status: action.payload.status
      });
    default:
      return state;
  }
};
var initialState = {
  userObjects: {}
};
var UserObjectStoreProvider = function UserObjectStoreProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(Reducer, initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  return /*#__PURE__*/React__default.createElement(UserObjectContext.Provider, {
    value: [state, dispatch]
  }, children);
};
var UserObjectContext = createContext(initialState);
var cookies = new Cookies();
var isBrowser = function isBrowser() {
  return typeof window !== "undefined";
};
var apiUrl = function apiUrl() {
  return process.env.REACT_APP_API_URL || process.env.GATSBY_API_URL || process.env.GATSBY_STRAPI_SRC || null;
};
var encodeData = function encodeData(data) {
  if (isBrowser() && data) {
    if (typeof btoa === "function") {
      try {
        return btoa(JSON.stringify(data));
      } catch (e) {
        console.warn(e);
        return JSON.stringify(data);
      }
    }
  }
  return data;
};
var decodeData = function decodeData(data) {
  if (isBrowser() && data) {
    if (typeof atob === "function") {
      try {
        return JSON.parse(atob(data));
      } catch (e) {
        console.warn(e);
        if (typeof data === 'string') {
          return JSON.parse(data);
        } else {
          return data;
        }
      }
    }
  }
  return data;
};
var cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN || process.env.GATSBY_COOKIE_DOMAIN || null;
var storeData = function storeData(key, value, type) {
  if (type === void 0) {
    type = 'token';
  }
  if (isBrowser()) {
    var expires = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    if (type === 'auth') expires = new Date(new Date().setMinutes(new Date().getMinutes() + 15));
    var options = {
      expires: expires,
      sameSite: true,
      path: '/'
    };
    if (cookieDomain) options["domain"] = cookieDomain;
    cookies.set(key, value, options);
  }
};
var getData = function getData(key) {
  return isBrowser() ? cookies.get(key) : null;
};
var removeData = function removeData(key) {
  if (isBrowser()) {
    var options = {
      path: '/'
    };
    cookies.remove(key, options);
    if (cookieDomain) options["domain"] = cookieDomain;
    cookies.remove(key, options);
  }
};
var storeUserData = function storeUserData(user) {
  var userData = {
    name: user.forename || user.username || user.email,
    email: user.email,
    mobile: user.mobile || user.telephone,
    uid: user.id,
    contact_id: get(user, 'contact_id[0]', false),
    picture: getUserPicture(user)
  };
  storeData("suser", encodeData(userData));
};
var getUser = function getUser() {
  return isBrowser() ? decodeData(cookies.get("suser")) : {};
};
var getToken = function getToken() {
  return isBrowser() ? cookies.get("sjwt") : null;
};
var getLoginAttempt = function getLoginAttempt(key) {
  var hasLoginAttempt = isBrowser() ? cookies.get(key) : null;
  if (hasLoginAttempt) removeData(key);
  return hasLoginAttempt;
};
var getUserPicture = function getUserPicture(user) {
  return (user === null || user === void 0 ? void 0 : user.picture) || (user === null || user === void 0 ? void 0 : user.social_picture) || null;
};
var doLogout = function doLogout() {
  removeData('sjwt');
  removeData('suser');
};
var isAuthenticated = function isAuthenticated() {
  if (isBrowser()) {
    return !!getData('sjwt');
  } else {
    return false;
  }
};
var storeLoginAttempt = function storeLoginAttempt(key) {
  if (key === void 0) {
    key = "sdologin";
  }
  storeData(key, true, 'auth');
};
var canDoPostLoginAction = function canDoPostLoginAction(key) {
  if (key === void 0) {
    key = "sdologin";
  }
  return isAuthenticated() && getLoginAttempt(key);
};
var querystring = function querystring(params) {
  return new URLSearchParams(params).toString();
};
var baseURL = apiUrl();
var token = getToken();
var API_PREFIX = process.env.GATSBY_API_PREFIX || '';
var instance = axios.create({
  baseURL: baseURL
});
var authInstance = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: "Bearer " + token
  }
});
var updateToken = function updateToken(authToken) {
  authInstance.defaults.headers["Authorization"] = "Bearer " + authToken;
};
var login = function login(values) {
  return instance.post(API_PREFIX + "/auth/local", {
    identifier: values.email,
    password: values.password
  });
};
var register = function register(values) {
  return instance.post(API_PREFIX + "/auth/local/register", _extends({}, values, {
    username: values.email
  }));
};
var providerLogin = function providerLogin(values) {
  return instance.get("/stb-users" + API_PREFIX + "/auth/" + values.provider + "/callback" + values.params);
};
var forgotPassword = function forgotPassword(values) {
  try {
    return Promise.resolve(instance.post(API_PREFIX + "/auth/forgot-password", values));
  } catch (e) {
    return Promise.reject(e);
  }
};
var emailConfirmation = function emailConfirmation(params) {
  try {
    return Promise.resolve(instance.get(API_PREFIX + "/auth/confirm-email?" + querystring(params)));
  } catch (e) {
    return Promise.reject(e);
  }
};
var resetPassword = function resetPassword(values) {
  try {
    return Promise.resolve(instance.post(API_PREFIX + "/auth/reset-password", values));
  } catch (e) {
    return Promise.reject(e);
  }
};
var getUserProfile = function getUserProfile(params) {
  return authInstance.get(API_PREFIX + "/users/me", params);
};
var hasPersona = function hasPersona() {
  return authInstance.get("/myaccount/has-personas");
};
var getUserobjects = function getUserobjects(params) {
  return authInstance.get(API_PREFIX + "/stb-users/userobjects?" + querystring(params));
};
var createUserobject = function createUserobject(params) {
  return authInstance.post(API_PREFIX + "/stb-users/userobjects", params);
};
var updateUserobject = function updateUserobject(params) {
  return authInstance.put(API_PREFIX + "/stb-users/userobjects/" + params.id, params);
};
var deleteUserobject = function deleteUserobject(params) {
  return authInstance["delete"](API_PREFIX + "/stb-users/userobjects/" + params.id, params);
};
var updatePropertyPreference = function updatePropertyPreference(params) {
  return authInstance.post(API_PREFIX + "/stb-users/propertypreference", params);
};
var getProperties = function getProperties(params) {
  return authInstance.get("/properties?" + querystring(params));
};
var unsubscribe = function unsubscribe(params) {
  return instance.put(API_PREFIX + "/stb-users/alert/property/unsubscribe", params);
};
var postForm = function postForm(params) {
  return authInstance.post(API_PREFIX + "/stb-forms/forms", params);
};
var getPendingActionCount = function getPendingActionCount(params) {
  return authInstance.get("/myaccount/pendingactionscount?" + querystring(params));
};
var getActionAllowed = function getActionAllowed(params) {
  return authInstance.get("/myaccount/property/" + params.property_id + "/actionAllowed");
};
var API_ERROR_MESSAGE = 'Something went wrong. Please try again.';
var sortByKeys = function sortByKeys(object) {
  return Object.keys(object).sort().reduce(function (obj, key) {
    obj[key] = object[key];
    return obj;
  }, {});
};
var getUserobjectData = function getUserobjectData(payload) {
  try {
    return Promise.resolve(getUserobjects(payload)).then(function (userData) {
      return userData.status === 200 ? {
        success: true,
        message: userData.message,
        status: userData.status,
        data: userData.data
      } : {
        success: false,
        message: userData.message,
        status: userData.status
      };
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var services = function services(dispatch, actions) {
  var handleError = function handleError(error) {
    if (error.response) {
      var _error$response, _error$response$data;
      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.statusCode) === 401) doLogout();
      dispatch(actions.savedActions('API_ERROR', {
        message: error.response.data.message,
        status: error.response.status
      }));
    } else {
      dispatch(actions.savedActions('SERVICE_ERROR', {
        message: API_ERROR_MESSAGE,
        status: 500
      }));
    }
  };
  return {
    getUserobject: function getUserobject(payload) {
      dispatch(actions.savedActions("DATA_LOADING", {
        loading: true
      }));
      getUserobjects(payload).then(function (res) {
        dispatch(actions.savedActions("GET_SAVED_PROPERTIES", res.data));
      })["catch"](function (error) {
        handleError(error);
      });
    },
    getUserobjectData: function (payload) {
      try {
        return Promise.resolve(getUserobjects(payload)).then(function (userData) {
          return userData.status === 200 ? {
            success: true,
            message: userData.message,
            status: userData.status,
            data: userData.data
          } : {
            success: false,
            message: userData.message,
            status: userData.status
          };
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getProperties: function getProperties$1(payload) {
      getProperties(payload).then(function (res) {
        dispatch(actions.savedActions("GET_PROPERTIES", res.data));
      })["catch"](function (error) {
        handleError(error);
      });
    },
    createUserobject: function createUserobject$1(payload) {
      createUserobject(payload).then(function (res) {
        dispatch(actions.savedActions("SAVE_PROPERTY", res.data));
      })["catch"](function (error) {
        handleError(error);
      });
    },
    updateUserobject: function updateUserobject$1(payload) {
      updateUserobject(payload).then(function (res) {
        dispatch(actions.savedActions("UPDATE_SAVED_PROPERTY", res.data));
      })["catch"](function (error) {
        handleError(error);
      });
    },
    deleteUserobject: function deleteUserobject$1(payload) {
      deleteUserobject(payload).then(function (res) {
        dispatch(actions.savedActions("DELETE_SAVED_PROPERTY", res.data));
      })["catch"](function (error) {
        handleError(error);
      });
    },
    updatePropertyPreference: function updatePropertyPreference$1(payload) {
      updatePropertyPreference(payload).then(function (res) {
        dispatch(actions.savedActions("SAVE_PROPERTY", res.data));
      })["catch"](function (error) {
        handleError(error);
      });
    },
    isSaved: function isSaved(userObjects, params, type) {
      if (isEmpty(userObjects) || isEmpty(userObjects[type])) return false;
      var lParams = sortByKeys(params);
      lParams = JSON.stringify(lParams).toLowerCase();
      return !!userObjects[type].filter(function (x) {
        var itemParams = sortByKeys(x.params);
        itemParams = JSON.stringify(itemParams).toLowerCase();
        return itemParams === lParams && x.state;
      }).length;
    },
    unsubscribe: function unsubscribe$1(payload) {
      unsubscribe(payload).then(function (res) {
        dispatch(actions.savedActions("UNSUBSCRIBE", res.data));
      })["catch"](function (error) {
        handleError(error);
      });
    }
  };
};
var savedActions = function savedActions(type, payload) {
  return {
    type: type,
    payload: payload
  };
};
var Actions = {
  __proto__: null,
  savedActions: savedActions
};
var useUserObjectState = function useUserObjectState() {
  var _useContext = useContext(UserObjectContext),
    state = _useContext[0],
    dispatch = _useContext[1];
  var store = {
    state: _extends({}, state),
    services: _extends({}, services(dispatch, Actions))
  };
  return store;
};
var Reducer$1 = function Reducer(state, action) {
  var _data, _action$payload, _action$payload2, _data$user;
  switch (action.type) {
    case 'LOGIN_PROCESS':
      var data = action.payload.data;
      return _extends({}, state, {
        jwt: data.jwt,
        user: _extends({}, data.user, {
          name: data.user.forename || data.user.username || data.user.email,
          uid: data.user.id,
          contact_id: get(data.user, 'contact_id[0]', false),
          picture: getUserPicture(data.user)
        }),
        loading: false,
        success: true,
        error: false,
        status: action.payload.status,
        message: ''
      });
    case 'LOADING':
      return _extends({}, state, {
        success: false,
        loading: true,
        error: false
      });
    case 'LOGIN_ERROR':
      return _extends({}, state, {
        loading: false,
        error: true,
        message: action.payload.message[0].messages[0].message,
        status: action.payload.status
      });
    case 'API_ERROR':
      return _extends({}, state, {
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status
      });
    case 'TOKEN_ERROR':
      return _extends({}, state, {
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status
      });
    case 'VERIFY_EMAIL':
      return _extends({}, state, {
        success: true,
        loading: false,
        error: false,
        status: action.payload.status,
        message: 'Account confirmation Email send. Please check your inbox'
      });
    case 'PROVIDER_LOGIN_ERROR':
      return _extends({}, state, {
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status
      });
    case 'USER_LOGOUT':
      return {
        user: null,
        loading: false,
        error: false
      };
    case 'FORGOT_PASSWORD':
      return _extends({}, state, {
        success: true,
        loading: false,
        error: false,
        message: action.payload.data.ok ? 'Please check your Inbox to reset your password' : 'Somthing went wrong',
        status: action.payload.status
      });
    case 'GET_USER_DATA':
      data = action.payload.data;
      return _extends({}, state, {
        profile: data,
        user: {
          name: data.forename || data.username || data.email,
          job_title: (_data = data) === null || _data === void 0 ? void 0 : _data.job_title,
          uid: data.id,
          contact_id: get(data, 'contact_id[0]', false)
        },
        success: true,
        loading: false,
        error: false,
        message: '',
        status: action.payload.status
      });
    case 'RESET_MESSAGE':
      return _extends({}, state, {
        success: false,
        loading: false,
        error: false,
        message: false
      });
    case 'UPDATE_MESSAGE':
      return _extends({}, state, {
        success: false,
        loading: false,
        error: false,
        pendingItemsCount: (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.pendingItemsCount) || 0,
        message: (action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.message) || "Profile Updated"
      });
    case 'GET_PENDING_ACTIONS_COUNT':
      return _extends({}, state, {
        pendingItemsCount: action !== null && action !== void 0 && action.payload ? action.payload.count : 0,
        pendingItemsCountCall: true
      });
    case 'PROFILE_UPDATE':
      data = action.payload.data;
      return _extends({}, state, {
        success: true,
        loading: false,
        error: false,
        profile: data,
        user: {
          name: data.user.forename || data.user.username || data.user.email,
          job_title: (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.job_title,
          uid: data.user.id,
          contact_id: get(data.user, 'contact_id[0]', false)
        },
        message: action.payload.data ? 'Profile Updated' : action.payload.data,
        status: action.payload.status
      });
    case 'SERVICE_ERROR':
      return _extends({}, state, {
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status
      });
    case 'UPDATE_STATE':
      return _extends({}, state, action.payload);
    case 'UPDATE_PERSONA':
      return _extends({}, state, {
        hasPersona: action.payload.data
      });
    default:
      return state;
  }
};
var initialState$1 = {
  user: getUser(),
  loading: false,
  error: null,
  status: null,
  pageTitle: null
};
var AuthStoreProvider = function AuthStoreProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(Reducer$1, initialState$1),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  return /*#__PURE__*/React__default.createElement(AuthContext.Provider, {
    value: [state, dispatch]
  }, children);
};
var AuthContext = createContext(initialState$1);
var baseURL$1 = apiUrl();
var storeToken = function storeToken(data) {
  if (isBrowser()) {
    storeData('sjwt', data.jwt);
    storeUserData(data.user);
  }
  updateToken(data.jwt);
};
var services$1 = function services(dispatch, actions) {
  var handleError = function handleError(error) {
    if (error.response) {
      var _error$response, _error$response$data;
      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.statusCode) === 401) doLogout();
      dispatch(actions.apiError({
        message: error.response.data.message,
        status: error.response.status
      }));
    } else {
      dispatch(actions.serviceError({
        message: API_ERROR_MESSAGE,
        status: 500
      }));
    }
  };
  var handleAuthError = function handleAuthError(error) {
    if (error.response) {
      dispatch(actions.authError({
        message: error.response.data.message,
        status: error.response.status
      }));
    } else {
      dispatch(actions.serviceError({
        message: API_ERROR_MESSAGE,
        status: 500
      }));
    }
  };
  return {
    storeData: function storeData$1(key, value) {
      storeData(key, value);
    },
    getData: function getData$1(key) {
      return getData(key);
    },
    removeData: function removeData$1(key) {
      removeData(key);
    },
    registerWithEmail: function registerWithEmail(payload) {
      dispatch(actions.authLoading());
      register(payload).then(function (res) {
        if (res.data.user.confirmed) {
          storeToken(res.data);
          dispatch(actions.authProcess(res));
        } else {
          dispatch(actions.verifyProcess(res));
        }
      })["catch"](function (error) {
        handleAuthError(error);
      });
    },
    loginWithEmail: function loginWithEmail(payload) {
      dispatch(actions.authLoading());
      login(payload).then(function (res) {
        storeToken(res.data);
        dispatch(actions.authProcess(res));
      })["catch"](function (error) {
        handleAuthError(error);
      });
    },
    isAuthenticated: function isAuthenticated() {
      if (isBrowser()) {
        return !!getData('sjwt');
      } else {
        return false;
      }
    },
    logout: function logout() {
      doLogout();
    },
    providerAuthLogin: function providerAuthLogin(provider, params) {
      providerLogin({
        provider: provider,
        params: params
      }).then(function (res) {
        storeToken(res.data);
        dispatch(actions.authProcess(res));
      })["catch"](function (error) {
        handleError(error);
      });
    },
    forgottenPassword: function (payload) {
      try {
        return Promise.resolve(forgotPassword(payload).then(function (res) {
          dispatch(actions.forgotPassword(res));
        })["catch"](function (error) {
          handleAuthError(error);
        })).then(function () {});
      } catch (e) {
        return Promise.reject(e);
      }
    },
    resetPassword: function (payload) {
      try {
        return Promise.resolve(resetPassword(payload).then(function (res) {
          storeToken(res.data);
          dispatch(actions.authProcess(res));
        })["catch"](function (error) {
          handleAuthError(error);
        })).then(function () {});
      } catch (e) {
        return Promise.reject(e);
      }
    },
    emailConfirmation: function (payload) {
      try {
        return Promise.resolve(emailConfirmation(payload).then(function (res) {
          storeToken(res.data);
          dispatch(actions.authProcess(res));
        })["catch"](function (error) {
          handleError(error);
        })).then(function () {});
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getUserProfile: function (payload) {
      try {
        return Promise.resolve(getUserProfile(payload).then(function (res) {
          storeUserData(res.data);
          dispatch(actions.getUserData(res));
        })["catch"](function (error) {
          handleError(error);
        })).then(function () {});
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getPendingActionsCount: function (payload) {
      try {
        getPendingActionCount(payload).then(function (res) {
          dispatch(actions.getPendingActionCount(res.data));
        })["catch"](function (error) {
          handleError(error);
        });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    resetMessage: function (payload) {
      try {
        dispatch(actions.resetMessage(payload));
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    updateMessage: function (payload) {
      try {
        dispatch(actions.updateMessage(payload));
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    createUserobject: function createUserobject$1(payload) {
      createUserobject(payload).then(function (res) {});
    },
    createUserobjectNoState: function (payload) {
      try {
        return Promise.resolve(createUserobject(payload));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    hasPersona: function () {
      try {
        return Promise.resolve(hasPersona()).then(function (test) {
          return test.data;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    updateState: function updateState(payload) {
      dispatch(actions.updateState(payload));
    },
    providerLogin: function providerLogin(provider) {
      if (isBrowser()) {
        window.location.href = baseURL$1 + "/connect/" + provider;
      }
    }
  };
};
var authProcess = function authProcess(payload) {
  return {
    type: 'LOGIN_PROCESS',
    payload: payload
  };
};
var verifyProcess = function verifyProcess(payload) {
  return {
    type: 'VERIFY_EMAIL',
    payload: payload
  };
};
var updatePersona = function updatePersona(payload) {
  return {
    type: 'UPDATE_PERSONA',
    payload: payload
  };
};
var authLoading = function authLoading(payload) {
  return {
    type: 'LOADING',
    payload: payload
  };
};
var authError = function authError(payload) {
  return {
    type: 'LOGIN_ERROR',
    payload: payload
  };
};
var tokenError = function tokenError(payload) {
  return {
    type: 'TOKEN_ERROR',
    payload: payload
  };
};
var providerLoginError = function providerLoginError(payload) {
  return {
    type: 'PROVIDER_LOGIN_ERROR',
    payload: payload
  };
};
var authLogout = function authLogout(payload) {
  return {
    type: 'USER_LOGOUT',
    payload: payload
  };
};
var authlogin = function authlogin(payload) {
  return {
    type: 'USER_LOGIN',
    payload: payload
  };
};
var forgotPassword$1 = function forgotPassword(payload) {
  return {
    type: 'FORGOT_PASSWORD',
    payload: payload
  };
};
var resetPassword$1 = function resetPassword(payload) {
  return {
    type: 'RESET_PASSWORD',
    payload: payload
  };
};
var profileUpdate = function profileUpdate(payload) {
  return {
    type: 'PROFILE_UPDATE',
    payload: payload
  };
};
var getUserData = function getUserData(payload) {
  return {
    type: 'GET_USER_DATA',
    payload: payload
  };
};
var resetMessage = function resetMessage(payload) {
  return {
    type: 'RESET_MESSAGE',
    payload: payload
  };
};
var updateMessage = function updateMessage(payload) {
  return {
    type: 'UPDATE_MESSAGE',
    payload: payload
  };
};
var updateState = function updateState(payload) {
  return {
    type: 'UPDATE_STATE',
    payload: payload
  };
};
var getPendingActionCount$1 = function getPendingActionCount(payload) {
  return {
    type: 'GET_PENDING_ACTIONS_COUNT',
    payload: payload
  };
};
var serviceError = function serviceError(payload) {
  return {
    type: 'SERVICE_ERROR',
    payload: payload
  };
};
var apiError = function apiError(payload) {
  return {
    type: 'API_ERROR',
    payload: payload
  };
};
var Actions$1 = {
  __proto__: null,
  authProcess: authProcess,
  verifyProcess: verifyProcess,
  updatePersona: updatePersona,
  authLoading: authLoading,
  authError: authError,
  tokenError: tokenError,
  providerLoginError: providerLoginError,
  authLogout: authLogout,
  authlogin: authlogin,
  forgotPassword: forgotPassword$1,
  resetPassword: resetPassword$1,
  profileUpdate: profileUpdate,
  getUserData: getUserData,
  resetMessage: resetMessage,
  updateMessage: updateMessage,
  updateState: updateState,
  getPendingActionCount: getPendingActionCount$1,
  serviceError: serviceError,
  apiError: apiError
};
var useAuthState = function useAuthState() {
  var _useContext = useContext(AuthContext),
    state = _useContext[0],
    dispatch = _useContext[1];
  var store = {
    state: _extends({}, state),
    services: _extends({}, services$1(dispatch, Actions$1))
  };
  return store;
};
var Reducer$2 = function Reducer(state, action) {
  var _action$payload, _action$payload$data, _action$payload2, _action$payload3, _action$payload4;
  switch (action.type) {
    case "FORM_REFRESH":
      return _extends({}, state, {
        loading: false,
        error: false,
        success: false,
        data: false,
        step: false,
        message: ""
      });
    case "FORM_LOADING":
      return _extends({}, state, {
        loading: true,
        error: false,
        success: false,
        message: ""
      });
    case "FORM_POST_ERROR":
      return _extends({}, state, {
        loading: false,
        error: true,
        success: false,
        data: false,
        message: action.payload.message
      });
    case "FORM_POST_SUCCESS":
      return _extends({}, state, {
        loading: false,
        error: false,
        success: true,
        data: action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$data = _action$payload.data) === null || _action$payload$data === void 0 ? void 0 : _action$payload$data.data,
        step: action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.step,
        message: (action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.message) || "Form Post Successfully."
      });
    case "CHANGE_FORM_STATE":
      return _extends({}, state, action.payload);
    case "GET_ACTION_ALLOWED":
      return _extends({}, state, {
        loading: false,
        error: false,
        success: true,
        allowedActions: action === null || action === void 0 ? void 0 : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.data,
        message: ''
      });
    default:
      return state;
  }
};
var initialState$2 = {};
var FormStoreProvider = function FormStoreProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(Reducer$2, initialState$2),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  return /*#__PURE__*/React__default.createElement(FormContext.Provider, {
    value: [state, dispatch]
  }, children);
};
var FormContext = createContext(initialState$2);
var services$2 = function services(dispatch, actions) {
  var handleError = function handleError(error) {
    if (error.response) {
      var _error$response, _error$response$data;
      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.statusCode) === 401) doLogout();
      dispatch(actions.formActions('API_ERROR', {
        message: error.response.data.message,
        status: error.response.status
      }));
    } else {
      dispatch(actions.formActions('SERVICE_ERROR', {
        message: API_ERROR_MESSAGE,
        status: 500
      }));
    }
  };
  return {
    postForm: function postForm$1(payload) {
      var _postData, _postData2, _postData3;
      var postData = _extends({}, payload);
      if ((_postData = postData) !== null && _postData !== void 0 && _postData.step) delete postData.step;
      if ((_postData2 = postData) !== null && _postData2 !== void 0 && _postData2.nextStep) delete postData.nextStep;
      if ((_postData3 = postData) !== null && _postData3 !== void 0 && _postData3.successMessage) delete postData.successMessage;
      if (payload !== null && payload !== void 0 && payload.multipart) {
        var _postData4;
        var formData = new FormData();
        if ((_postData4 = postData) !== null && _postData4 !== void 0 && _postData4.file) {
          formData.append('files.attachment', postData.file, postData.file.name);
        }
        formData.append('data', JSON.stringify(postData));
        postData = formData;
      }
      dispatch(actions.formActions("FORM_LOADING"));
      postForm(postData).then(function (res) {
        var response = _extends({}, res);
        if (payload !== null && payload !== void 0 && payload.step) response['step'] = payload !== null && payload !== void 0 && payload.step ? payload === null || payload === void 0 ? void 0 : payload.step : 'default';
        if (payload !== null && payload !== void 0 && payload.nextStep) response['step'] = payload === null || payload === void 0 ? void 0 : payload.nextStep;
        if (payload !== null && payload !== void 0 && payload.successMessage) response['message'] = payload === null || payload === void 0 ? void 0 : payload.successMessage;
        dispatch(actions.formActions("FORM_POST_SUCCESS", response));
      })["catch"](function (error) {
        if (error.response) {
          dispatch(actions.formActions("FORM_POST_ERROR", {
            message: error.response.data.message,
            status: error.response.status
          }));
        } else {
          dispatch(actions.formActions("FORM_POST_ERROR", {
            message: API_ERROR_MESSAGE,
            status: 500
          }));
        }
      });
    },
    formProcessing: function formProcessing(payload) {
      dispatch(actions.formActions("FORM_LOADING"));
    },
    resetForm: function resetForm(payload) {
      dispatch(actions.formActions("FORM_REFRESH"));
    },
    changeFormState: function changeFormState(payload) {
      dispatch(actions.formActions("CHANGE_FORM_STATE", payload));
    },
    getActionAllowed: function getActionAllowed$1(payload) {
      dispatch(actions.formActions("FORM_LOADING", {
        loading: true
      }));
      getActionAllowed(payload).then(function (res) {
        dispatch(actions.formActions("GET_ACTION_ALLOWED", res));
      })["catch"](function (error) {
        handleError(error);
      });
    }
  };
};
var formActions = function formActions(type, payload) {
  return {
    type: type,
    payload: payload
  };
};
var Actions$2 = {
  __proto__: null,
  formActions: formActions
};
var useFormState = function useFormState() {
  var _useContext = useContext(FormContext),
    state = _useContext[0],
    dispatch = _useContext[1];
  var store = {
    state: _extends({}, state),
    services: _extends({}, services$2(dispatch, Actions$2))
  };
  return store;
};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
var isConcurrentMode = A;
var isContextConsumer = function (a) {
  return z(a) === k;
};
var isContextProvider = function (a) {
  return z(a) === h;
};
var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function (a) {
  return z(a) === n;
};
var isFragment = function (a) {
  return z(a) === e;
};
var isLazy = function (a) {
  return z(a) === t;
};
var isMemo = function (a) {
  return z(a) === r;
};
var isPortal = function (a) {
  return z(a) === d;
};
var isProfiler = function (a) {
  return z(a) === g;
};
var isStrictMode = function (a) {
  return z(a) === f;
};
var isSuspense = function (a) {
  return z(a) === p;
};
var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function () {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;
var printWarning$1 = function () {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var baseURL$2 = apiUrl();
var providersNames = ['facebook', 'google'];
var AuthProvider = function AuthProvider(props) {
  if (!providersNames.includes(props.providerName)) return /*#__PURE__*/React__default.createElement("p", null, "Please use available provider only ", JSON.stringify(providersNames));
  return /*#__PURE__*/React__default.createElement("a", {
    href: baseURL$2 + "/connect/" + props.providerName,
    className: "provider " + props.providerName
  }, props.providerLabel ? props.providerLabel : props.providerName);
};
AuthProvider.propTypes = {
  providerName: propTypes.string.isRequired,
  providerLabel: propTypes.string
};
var doRedirect = function doRedirect(url) {
  if (typeof window !== "undefined") {
    window.location.href = url;
  }
};
var useQuery = function useQuery(location, key) {
  var query = new URLSearchParams(location.search);
  return query.get(key);
};
var goBack = function goBack() {
  navigate(-1);
};
var savedSearchParams = function savedSearchParams(params) {
  var areas = params.areas,
    bedrooms = params.bedrooms,
    bedroom = params.bedroom,
    pType = params.pType,
    type = params.type,
    price = params.price,
    minPrice = params.minPrice,
    maxPrice = params.maxPrice,
    department = params.department,
    search_type = params.search_type,
    building = params.building,
    propertyType = params.propertyType,
    bathrooms = params.bathrooms,
    bathroom = params.bathroom,
    maxAreaSize = params.maxAreaSize,
    minAreaSize = params.minAreaSize,
    feature = params.feature,
    minBedroom = params.minBedroom,
    maxBedroom = params.maxBedroom;
  var bedroomValue = bedrooms || bedroom;
  var bathroomValue = bathroom || bathrooms;
  var searchParams = {
    department: (department || '').toLowerCase(),
    search_type: (pType || search_type || '').toLowerCase(),
    areas: areas
  };
  if (typeof maxAreaSize === 'string') {
    searchParams["maxAreaSize"] = maxAreaSize;
  }
  if (typeof minAreaSize === 'string') {
    searchParams["minAreaSize"] = minAreaSize;
  }
  if (typeof feature === 'string') {
    searchParams["feature"] = feature;
  }
  if (typeof bedroomValue === 'string') {
    searchParams["bedroom"] = bedroomValue;
  }
  if (typeof minBedroom === 'string') {
    searchParams["minBedroom"] = minBedroom;
  }
  if (typeof maxBedroom === 'string') {
    searchParams["maxBedroom"] = maxBedroom;
  }
  if (typeof bedroomValue === 'object') {
    searchParams["minBedroom"] = (bedroomValue === null || bedroomValue === void 0 ? void 0 : bedroomValue.min) || '';
    searchParams["maxBedroom"] = (bedroomValue === null || bedroomValue === void 0 ? void 0 : bedroomValue.max) || '';
  }
  if (typeof bathroomValue === 'string') {
    searchParams["bathroom"] = bathroomValue;
  }
  if (typeof bathroomValue === 'object') {
    searchParams["minBathroom"] = (bathroomValue === null || bathroomValue === void 0 ? void 0 : bathroomValue.min) || '';
    searchParams["maxBathroom"] = (bathroomValue === null || bathroomValue === void 0 ? void 0 : bathroomValue.max) || '';
  }
  searchParams["minPrice"] = (price === null || price === void 0 ? void 0 : price.min) || (price === null || price === void 0 ? void 0 : price.minPrice) || minPrice || '';
  searchParams["maxPrice"] = (price === null || price === void 0 ? void 0 : price.max) || (price === null || price === void 0 ? void 0 : price.maxPrice) || maxPrice || '';
  searchParams["building"] = (type || building || propertyType || '').toLowerCase();
  return pickBy(searchParams, identity);
};
var trackEvents = function trackEvents(params) {
  console.log("trackEvents => ", params);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(_extends({}, params));
};
var trackSaveItem = function trackSaveItem(props) {
  if (props === void 0) {
    props = {};
  }
  trackEvents(_extends({
    event: 'formSubmit',
    eventId: 'Save Property'
  }, props));
};
var _excluded = ["children"];
var SaveProperty = function SaveProperty(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useUserObjectState = useUserObjectState(),
    state = _useUserObjectState.state,
    services = _useUserObjectState.services;
  var _useAuthState = useAuthState(),
    authServices = _useAuthState.services;
  var isAuthenticated = authServices.isAuthenticated();
  var _useState = useState(merge(props.userObjects || {}, state.userObjects)),
    savedResponse = _useState[0],
    setSavedResponse = _useState[1];
  useEffect(function () {
    setSavedResponse((!isEmpty(state.userObjects) ? state.userObjects : props.userObjects) || {});
  }, [props.userObjects, state.userObjects]);
  var handleSaveProperty = function handleSaveProperty(params, status, type) {
    var saveparams = {
      params: params,
      type: type,
      state: status
    };
    if (!isAuthenticated) {
      storeData('auth_params', saveparams, 'auth');
      storeData('auth_return', typeof window !== "undefined" ? window.location.href : '', 'auth');
      doRedirect(process.env.GATSBY_MYACCOUNT_URL);
    } else {
      services.createUserobject(saveparams);
      trackSaveItem({
        eventId: "Save " + type,
        eventLabel: status ? 'Save' : 'Unsave'
      });
    }
  };
  var isSaved = function isSaved(params, type) {
    if (!isAuthenticated) return false;
    if (savedResponse) return services.isSaved(savedResponse, params, type);
  };
  var params = props.searchParams ? props.searchParams : {
    id: props.pid
  };
  var isSavedItem;
  if (savedResponse) {
    isSavedItem = isSaved(params, props.type);
  }
  var savedClass = "wishlist-icn";
  if (isSavedItem) {
    savedClass = "wishlist-icn saved";
  }
  return /*#__PURE__*/createElement(Fragment$1, null, /*#__PURE__*/createElement("div", {
    className: "sb-myacc icon " + savedClass + " " + (props === null || props === void 0 ? void 0 : props.className),
    onClick: function onClick() {
      handleSaveProperty(params, !isSavedItem, props.type);
    }
  }, children));
};
export { AuthContext, AuthProvider, AuthStoreProvider, FormContext, FormStoreProvider, SaveProperty as SaveItem, UserObjectContext, UserObjectStoreProvider, apiUrl, canDoPostLoginAction, doLogout, doRedirect, getData, getToken, getUser, getUserPicture, getUserobjectData, getUserobjects as getUserobjectDataApi, goBack, isAuthenticated, isBrowser, removeData, savedSearchParams, storeData, storeLoginAttempt, storeUserData, useAuthState, useFormState, useQuery, useUserObjectState };